function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["variant", "size", "children", "disabled", "onClick", "className"],
  _excluded2 = ["style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { colors, spacing, typography } from '../tokens';
import { jsx as _jsx } from "react/jsx-runtime";
export function Button(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    children = _ref.children,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutProperties(_ref, _excluded);
  var getPadding = function getPadding() {
    switch (size) {
      case 'sm':
        return '4px 12px';
      case 'lg':
        return '12px 24px';
      default:
        return '8px 16px';
    }
  };
  var isLink = variant === 'link';
  var baseStyle = {
    fontFamily: typography.fontFamily,
    fontSize: typography.sizes[size] || typography.sizes.base,
    padding: isLink ? '0' : getPadding(),
    borderRadius: isLink ? '0' : '6px',
    border: variant === 'secondary' ? '1px solid var(--bafkal-border)' : 'none',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
    display: isLink ? 'inline' : 'inline-flex',
    alignItems: isLink ? undefined : 'center',
    justifyContent: isLink ? undefined : 'center',
    fontWeight: isLink ? 400 : 500,
    background: isLink ? 'none' : undefined,
    color: isLink ? colors.primary[600] : undefined,
    textDecoration: isLink ? 'underline' : 'none'
  };
  var customStyle = props.style,
    restProps = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
    style: _objectSpread(_objectSpread({}, baseStyle), customStyle),
    disabled: disabled,
    onClick: onClick,
    className: "bafkal-btn bafkal-btn-".concat(variant, " ").concat(className)
  }, restProps), {}, {
    children: children
  }));
}